import { Instagram, Linkedin } from "lucide-react";

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/the_next_move_by_rhellex/", Icon: Instagram },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/rheasharma/", Icon: Linkedin },
];

export const SocialLinks = ({ className = "", size = 18, tone = "dark" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="social-links">
    {SOCIALS.map(({ label, href, Icon }) => (
      <a
        key={label}
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label={label}
        data-testid={`social-${label.toLowerCase()}`}
        className={`inline-flex items-center justify-center w-10 h-10 border transition-colors duration-300 ${
          tone === "dark"
            ? "border-white/20 text-white/70 hover:text-white hover:border-white"
            : "border-[#E5E7EB] text-[#3A4A63] hover:text-[#041C3E] hover:border-[#041C3E]"
        }`}
      >
        <Icon size={size} />
      </a>
    ))}
  </div>
);
